import React from 'react';

const HistoryEventsContext = React.createContext({
  eventsOffsetIndexRef: { current: 0 },
});

export default HistoryEventsContext;
